import { GuestLookupCredentials, Order } from '../../types/order';
import { apiRequest, ApiError } from '../../services/apiClient';

interface LookupResponse {
  id: string;
  proofToken: string;
  orderNo: string;
  customerName: string;
  phone: string;
  status: Order['status'];
  workStatus?: Order['workStatus'];
  workStartedAt?: string | null;
  workCompletedAt?: string | null;
  carrier?: string | null;
  trackingNumber?: string | null;
  title?: string | null;
  company?: string | null;
  shape?: string | null;
  boxSize?: string | null;
  contentSize?: string | null;
  contentType?: string | null;
  quantity?: number;
  unitPrice?: number;
  totalPrice?: number;
  createdAt?: string;
  updatedAt?: string;
}

export async function lookupOrder(credentials: GuestLookupCredentials): Promise<Order | null> {
  try {
    const result = await apiRequest<LookupResponse>('/api/orders/lookup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // orderNo 가 비어 있으면 보내지 않음 → 서버는 가장 최근 주문을 조회
      body: JSON.stringify(credentials.orderNo ? credentials : { ...credentials, orderNo: undefined }),
    });

    return {
      id: result.id,
      proofToken: result.proofToken,
      orderNo: result.orderNo,
      customerName: result.customerName,
      phone: result.phone,
      status: result.status,
      workStatus: result.workStatus,
      workStartedAt: result.workStartedAt,
      workCompletedAt: result.workCompletedAt,
      carrier: result.carrier,
      trackingNumber: result.trackingNumber,
      title: result.title,
      company: result.company,
      shape: result.shape,
      boxSize: result.boxSize,
      contentSize: result.contentSize,
      contentType: result.contentType,
      quantity: result.quantity,
      unitPrice: result.unitPrice,
      totalPrice: result.totalPrice,
      createdAt: result.createdAt ?? '',
      updatedAt: result.updatedAt ?? '',
    };
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) {
      return null;
    }
    throw err;
  }
}
